<ng-template #textInputModalTemplate>
    <div class="modal-header">
        <h4 class="modal-title pull-left">{{ title }}</h4>
    </div>

    <div class="modal-body">
        <div class="form-group">
            <textarea
                *ngIf="isTextArea"
                [(ngModel)]="inputValue"
                [id]="inputId"
                [maxlength]="maxLength"
                [placeholder]="placeholder"
                [required]="required"
                [rows]="textAreaRows"
                class="form-control">
            </textarea>
            <input
                *ngIf="!isTextArea"
                [(ngModel)]="inputValue"
                [id]="inputId"
                [maxlength]="maxLength"
                [placeholder]="placeholder"
                [required]="required"
                [type]="inputType || 'text'"
                class="form-control">
        </div>
        <div *ngIf="showValidationErrors && validationErrors.length > 0" class="alert alert-danger">
            <ul class="mb-0">
                <li *ngFor='let error of validationErrors'>{{ error }}</li>
            </ul>
        </div>
    </div>

    <div class="modal-footer">
        <div class="row modal-confirm-button-row">
            <div *ngIf="showCancelButton" class="col-6">
                <button (click)="onCancel()" class="btn btn-outline-danger" type="button">
                    {{ cancelText }}
                </button>
            </div>
            <div [ngClass]="showCancelButton ? 'col-6 right-align' : 'col-12 right-align'">
                <button
                    (click)="onConfirm()"
                    [class]="confirmButtonClass"
                    [disabled]="required && (!inputValue || inputValue.trim().length === 0)"
                    type="button">
                    {{ confirmText }}
                </button>
            </div>
        </div>
    </div>
</ng-template>
